// Turbo + ActionCable (for turbo_stream_from broadcasts)
import * as Turbo from '@hotwired/turbo-rails'
import 'alpine-turbo-drive-adapter'

// Set up Alpine
import Alpine from 'alpinejs'
window.Alpine = Alpine

// Add alpine
import collapse from '@alpinejs/collapse'
import anchor from '@alpinejs/anchor'
import focus from '@alpinejs/focus'
import persist from '@alpinejs/persist'
import { registerAlpineExtensions } from './utils/alpine-extensions.js'

// Alpine components
import _glob_components_web_animations_counter from './components/web/animations/counter.js'
import _glob_components_web_animations_duurzaam_drukwerk from './components/web/animations/duurzaam-drukwerk.js'
import _glob_components_web_animations_fade_in from './components/web/animations/fade-in.js'
import _glob_components_web_animations_slide_in from './components/web/animations/slide-in.js'
import _glob_components_web_cart_options_modal from './components/web/cart-options-modal.js'
import _glob_components_web_checkout_communication from './components/web/checkout-communication.js'
import _glob_components_web_checkout_courier from './components/web/checkout-courier.js'
import _glob_components_web_checkout_recalculator from './components/web/checkout-recalculator.js'
import _glob_components_web_checkout_totals_refresher from './components/web/checkout-totals-refresher.js'
import _glob_components_web_count_selected_options from './components/web/count-selected-options.js'
import _glob_components_web_custom_dimensions from './components/web/custom-dimensions.js'
import _glob_components_web_design_button from './components/web/design-button.js'
import _glob_components_web_field_with_errors from './components/web/field-with-errors.js'
import _glob_components_web_file_upload from './components/web/file-upload.js'
import _glob_components_web_foils_choice_guide from './components/web/foils-choice-guide.js'
import _glob_components_web_gewicht_calculator from './components/web/gewicht-calculator.js'
import _glob_components_web_job_date_picker from './components/web/job-date-picker.js'
import _glob_components_web_main from './components/web/main.js'
import _glob_components_web_options from './components/web/options.js'
import _glob_components_web_photo_or_board_print_guide from './components/web/photo-or-board-print-guide.js'
import _glob_components_web_scroller from './components/web/scroller.js'
import _glob_components_web_search_nav from './components/web/search_nav.js'
import _glob_components_web_slider from './components/web/slider.js'
import _glob_components_web_timeline_range from './components/web/timeline-range.js'
import _glob_components_web_typeform_popover from './components/web/typeform-popover.js'
import _glob_components_web_typeform_popup from './components/web/typeform-popup.js'
import _glob_components_web_typeform_sidetab from './components/web/typeform-sidetab.js'
import _glob_components_web_typeform_slider from './components/web/typeform-slider.js'
import _glob_components_web_typeform_widget from './components/web/typeform-widget.js'
const webComponents = {
  'animations/counter': _glob_components_web_animations_counter,
  'animations/duurzaam-drukwerk': _glob_components_web_animations_duurzaam_drukwerk,
  'animations/fade-in': _glob_components_web_animations_fade_in,
  'animations/slide-in': _glob_components_web_animations_slide_in,
  'cart-options-modal': _glob_components_web_cart_options_modal,
  'checkout-communication': _glob_components_web_checkout_communication,
  'checkout-courier': _glob_components_web_checkout_courier,
  'checkout-recalculator': _glob_components_web_checkout_recalculator,
  'checkout-totals-refresher': _glob_components_web_checkout_totals_refresher,
  'count-selected-options': _glob_components_web_count_selected_options,
  'custom-dimensions': _glob_components_web_custom_dimensions,
  'design-button': _glob_components_web_design_button,
  'field-with-errors': _glob_components_web_field_with_errors,
  'file-upload': _glob_components_web_file_upload,
  'foils-choice-guide': _glob_components_web_foils_choice_guide,
  'gewicht-calculator': _glob_components_web_gewicht_calculator,
  'job-date-picker': _glob_components_web_job_date_picker,
  'main': _glob_components_web_main,
  'options': _glob_components_web_options,
  'photo-or-board-print-guide': _glob_components_web_photo_or_board_print_guide,
  'scroller': _glob_components_web_scroller,
  'search_nav': _glob_components_web_search_nav,
  'slider': _glob_components_web_slider,
  'timeline-range': _glob_components_web_timeline_range,
  'typeform-popover': _glob_components_web_typeform_popover,
  'typeform-popup': _glob_components_web_typeform_popup,
  'typeform-sidetab': _glob_components_web_typeform_sidetab,
  'typeform-slider': _glob_components_web_typeform_slider,
  'typeform-widget': _glob_components_web_typeform_widget
}
registerAlpineExtensions('data', webComponents)

import _glob_components_admin_detail_error_component from '../../components/admin/detail/error_component.js'
import _glob_components_admin_forms_uploader_component from '../../components/admin/forms/uploader_component.js'
import _glob_components_blocks_custom_format_component from '../../components/blocks/custom_format_component.js'
import _glob_components_blocks_horizontal_scroller_component from '../../components/blocks/horizontal_scroller_component.js'
import _glob_components_brochures_sheets_input_component from '../../components/brochures/sheets_input_component.js'
import _glob_components_clipboard_component from '../../components/clipboard_component.js'
import _glob_components_content_slider_component from '../../components/content/slider_component.js'
import _glob_components_form_switch_component from '../../components/form_switch_component.js'
import _glob_components_forms_password_field_component from '../../components/forms/password_field_component.js'
import _glob_components_jobs_option_picker_component from '../../components/jobs/option_picker_component.js'
import _glob_components_modal_component from '../../components/modal_component.js'
import _glob_components_my_address_fields_component from '../../components/my/address_fields_component.js'
import _glob_components_my_address_lookup_component from '../../components/my/address_lookup_component.js'
import _glob_components_my_address_picker_component from '../../components/my/address_picker_component.js'
import _glob_components_my_addresses_standard_card_component from '../../components/my/addresses/standard_card_component.js'
import _glob_components_my_estimates_delivery_picker_component from '../../components/my/estimates/delivery_picker_component.js'
import _glob_components_my_estimates_vat6_component from '../../components/my/estimates/vat6_component.js'
import _glob_components_products_custom_format_component from '../../components/products/custom_format_component.js'
import _glob_components_products_favorite_button_component from '../../components/products/favorite_button_component.js'
import _glob_components_products_order_button_component from '../../components/products/order_button_component.js'
import _glob_components_products_quantity_component from '../../components/products/quantity_component.js'
import _glob_components_shared_accordion_component from '../../components/shared/accordion_component.js'
import _glob_components_shared_active_search_component from '../../components/shared/active_search_component.js'
import _glob_components_shared_flash_component from '../../components/shared/flash_component.js'
import _glob_components_shared_frame_search_component from '../../components/shared/frame_search_component.js'
import _glob_components_shared_frame_sort_component from '../../components/shared/frame_sort_component.js'
import _glob_components_shared_totals_component from '../../components/shared/totals_component.js'
import _glob_components_static_data_flow_step_component from '../../components/static_data/flow_step_component.js'
import _glob_components_store_cart_job_component from '../../components/store/cart/job_component.js'
import _glob_components_upload_ring_component from '../../components/upload_ring_component.js'
import _glob_components_uploads_job_browser_component from '../../components/uploads/job/browser_component.js'
import _glob_components_uploads_job_component from '../../components/uploads/job_component.js'
const viewComponents = {
  'admin/detail/error_component': _glob_components_admin_detail_error_component,
  'admin/forms/uploader_component': _glob_components_admin_forms_uploader_component,
  'blocks/custom_format_component': _glob_components_blocks_custom_format_component,
  'blocks/horizontal_scroller_component': _glob_components_blocks_horizontal_scroller_component,
  'brochures/sheets_input_component': _glob_components_brochures_sheets_input_component,
  'clipboard_component': _glob_components_clipboard_component,
  'content/slider_component': _glob_components_content_slider_component,
  'form_switch_component': _glob_components_form_switch_component,
  'forms/password_field_component': _glob_components_forms_password_field_component,
  'jobs/option_picker_component': _glob_components_jobs_option_picker_component,
  'modal_component': _glob_components_modal_component,
  'my/address_fields_component': _glob_components_my_address_fields_component,
  'my/address_lookup_component': _glob_components_my_address_lookup_component,
  'my/address_picker_component': _glob_components_my_address_picker_component,
  'my/addresses/standard_card_component': _glob_components_my_addresses_standard_card_component,
  'my/estimates/delivery_picker_component': _glob_components_my_estimates_delivery_picker_component,
  'my/estimates/vat6_component': _glob_components_my_estimates_vat6_component,
  'products/custom_format_component': _glob_components_products_custom_format_component,
  'products/favorite_button_component': _glob_components_products_favorite_button_component,
  'products/order_button_component': _glob_components_products_order_button_component,
  'products/quantity_component': _glob_components_products_quantity_component,
  'shared/accordion_component': _glob_components_shared_accordion_component,
  'shared/active_search_component': _glob_components_shared_active_search_component,
  'shared/flash_component': _glob_components_shared_flash_component,
  'shared/frame_search_component': _glob_components_shared_frame_search_component,
  'shared/frame_sort_component': _glob_components_shared_frame_sort_component,
  'shared/totals_component': _glob_components_shared_totals_component,
  'static_data/flow_step_component': _glob_components_static_data_flow_step_component,
  'store/cart/job_component': _glob_components_store_cart_job_component,
  'upload_ring_component': _glob_components_upload_ring_component,
  'uploads/job/browser_component': _glob_components_uploads_job_browser_component,
  'uploads/job_component': _glob_components_uploads_job_component
}
registerAlpineExtensions('data', viewComponents, (s) =>
  s.replace(/.*components\//, '').replace(/_component$/, ''),
)

// Alpine directives (keep names kebab-case so `x-foo-bar` matches `foo_bar.js`)
import _glob_directives_autogrow from './directives/autogrow.js'
import _glob_directives_scroll_fade from './directives/scroll_fade.js'
const frontendDirectives = {
  'autogrow': _glob_directives_autogrow,
  'scroll_fade': _glob_directives_scroll_fade
}
for (const [name, callback] of Object.entries(frontendDirectives))
  Alpine.directive(name.replace(/_/g, '-'), callback)

// Alpine magics
import _glob_magics_flash from './magics/flash.js'
const frontendMagics = {
  'flash': _glob_magics_flash
}
registerAlpineExtensions('magic', frontendMagics)

// Alpine stores
import _glob_stores_modal from './stores/modal.js'
import _glob_stores_product_detail_tab from './stores/product-detail-tab.js'
const frontendStores = {
  'modal': _glob_stores_modal,
  'product-detail-tab': _glob_stores_product_detail_tab
}
registerAlpineExtensions('store', frontendStores)

// Alpine plugins
import { getCSRFToken } from './utils/security.js'
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(anchor)
Alpine.plugin(persist)

// Start Alpine
Alpine.start()

document.addEventListener('turbo:click', (event) => {
  const link = event.target.closest('a')

  if (link) {
    const href = link.getAttribute('href')

    if (href && href.startsWith('#')) {
      event.preventDefault()
      window.location.hash = href
    }
  }
})
